import { AppColors } from "@/styles/colors";
import { Button, Flex, Text } from "@chakra-ui/react";
import { Check, Info, X } from "lucide-react";
import { Dispatch, SetStateAction } from "react";

interface Props {
  loadingPresent: boolean;
  loadingSendInfo: boolean;
  loadingReject: boolean;
  setOpenInfoModal: Dispatch<SetStateAction<boolean>>;
  setOpenRejectModal: Dispatch<SetStateAction<boolean>>;
  onPresent: () => void;
  showPresent: boolean;
  showNeedsInfo: boolean;
  showReject: boolean;
}

export const PurchaseOrderIntentDetailActions = ({
  loadingPresent,
  loadingSendInfo,
  loadingReject,
  setOpenInfoModal,
  setOpenRejectModal,
  onPresent,
  showPresent,
  showNeedsInfo,
  showReject,
}: Props) => {
  return (
    <Flex gap="12px">
      {showPresent && (
        <Button
          paddingX="12px"
          height="32px"
          bgColor={AppColors.GREEN_PRIMARY}
          onClick={onPresent}
          disabled={loadingPresent || loadingSendInfo || loadingReject}
          loading={loadingPresent}
        >
          <Check />
          <Text fontWeight={600} fontSize="14px">
            Presentado
          </Text>
        </Button>
      )}
      {showNeedsInfo && (
        <Button
          paddingX="12px"
          height="32px"
          onClick={() => setOpenInfoModal(true)}
          disabled={loadingPresent || loadingSendInfo || loadingReject}
        >
          <Info />
          <Text fontWeight={600} fontSize="14px">
            En comunicación
          </Text>
        </Button>
      )}
      {showReject && (
        <Button
          paddingX="12px"
          height="32px"
          bgColor={AppColors.RED_ICON}
          onClick={() => setOpenRejectModal(true)}
          disabled={loadingPresent || loadingSendInfo || loadingReject}
        >
          <X />
          <Text fontWeight={600} fontSize="14px">
            Rechazar
          </Text>
        </Button>
      )}
    </Flex>
  );
};
